import { render } from "./NoSearchResultComponent.vue?vue&type=template&id=592dc2b3&scoped=true&ts=true"
import script from "./NoSearchResultComponent.vue?vue&type=script&lang=ts"
export * from "./NoSearchResultComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592dc2b3"]])

export default __exports__